import classNames from 'classnames'

import styles from './ProgressBar.module.scss'

const getProgressWidth = (statesLength: number, stateIndex: number): string => {
  if (stateIndex < 0) return '0px'

  if (statesLength === 3) {
    switch (stateIndex) {
      case 0:
        return '35px'
      case 1:
        return '50%'
      case 2:
        return '100%'
    }
  }

  if (statesLength === 4) {
    switch (stateIndex) {
      case 0:
        return '35px'
      case 1:
        return '37%'
      case 2:
        return '66%'
      case 3:
        return '100%'
    }
  }

  return '35px'
}

interface Props {
  progressStates: string[]
  stateIndex: number
}

export default function ProgressBar({ progressStates, stateIndex }: Props) {
  const progress = {
    stateIndex: stateIndex,
    states: progressStates,
    progressWidth: getProgressWidth(progressStates.length, stateIndex),
  }

  return (
    <div className={styles.progress_bar}>
      <div className={styles.bar_area}>
        <div className={styles.bar} style={{ width: progress.progressWidth }} />
      </div>
      <div className={styles.status_area}>
        {progress.states.map((progressMessage, idx) => {
          return (
            <span
              className={classNames(
                styles.txt,
                { [styles.passed]: idx < progress.stateIndex },
                { [styles.now]: idx === progress.stateIndex },
              )}
              aria-current={idx === progress.stateIndex ? 'true' : 'false'}
              key={progressMessage}
            >
              {progressMessage}
            </span>
          )
        })}
      </div>
    </div>
  )
}
